export type MarketingCampaignChannel = 'email' | 'sms';
export type MarketingArchiveStatusFilter = 'all' | 'active' | 'archived';

export interface CampaignInterface {
  id: string;
  name: string;
  description: string;
  channel?: MarketingCampaignChannel;
  status: CampaignTypeStatus;
  data: CampaignData;
  createdAt?: string;
  updatedAt?: string;
  groups: {
    id: string;
    name: string;
  }[];
}

export interface CampaignData {
  body: string;
  title: string;
  footer?: string;
  header?: string;
  subject: string;
}

export interface PostCampaignInterface {
  name: string;
  description: string;
  channel: MarketingCampaignChannel;
  data: CampaignData;
  groupIds?: string[];
}

export interface PutCampaignInterface {
  name?: string;
  description?: string;
  channel: MarketingCampaignChannel;
  data?: CampaignData;
  groupIds?: string[];
}

export enum CampaignTypeStatus {
  Active = 'active',
  Archived = 'archived',
  Completed = 'completed',
  Created = 'created',
  Sent = 'sent',
  Failed = 'failed',
  Bounced = 'bounced',
  Delivered = 'delivered',
  Opened = 'opened',
  Clicked = 'clicked',
  Dropped = 'dropped',
  Spam = 'spam',
  Unsubscribed = 'unsubscribed'
}
